<!-- 任务列表任务状态显示 -->
<template>
    <div class="function-status">
        <!-- 关闭进行中 -->
        <div class="status-txt" v-if="task.isCanceling">
            <div class="status-txt">
                <div class="task-waiting" style="display: flex;align-items: center;">
                    <img class="my_animation" src="@/assets/images/imageSaver/loading2.png" />
                    <div class="status-txt-text" style="padding-left:5px;">{{$t('language.common.canceling')}}</div>
                </div>
            </div>
        </div>
        <div v-else>
            <!-- 即时同步任务 -->
            <div class="status-txt" v-if="task.branchType&&task.branchType=='realtime'">
                <!-- 停止状态 -->
                <div v-if="task.status==0">
                    <div class="icon-paused" style="float: left;"></div>
                    <div class="status-txt-text" style="padding-left:5px;">{{$t('language.cloudSync.paused')}}</div>
                </div>
                <!-- 启动状态 -->
                <div v-if="task.status!=0&&progress" style="display: flex;align-items: center;">
                    <img class="my_animation" src="@/assets/images/imageSaver/loadingBlue.png" />
                    <div class="status-txt-text" style="padding-left:5px;">{{getPercentAndSpeed}}</div>
                </div>
                <div v-if="task.status!=0&&!progress" style="display: flex;align-items: center;">
                    <img class="my_animation" src="@/assets/images/imageSaver/loadingBlue.png" />
                    <div class="status-txt-text" style="padding-left:5px;">{{$t('language.cloudSync.realSyncing')}}</div>
                </div>
            </div>
            <!-- 非即时同步任务 -->
            <div class="status-txt" v-else>
                <!-- 关闭状态 -->
                <div v-if="task.status==0&&convertResult" class="status-txt-text" :class="'task-'+convertResult" :style="(task.type!=3&&task.type!=5)?'':'pointer-events: none;'" @click.stop="openPopup(1)">
                    {{$t('language.common.'+convertResult)}}
                </div>
                <!-- 运行状态 -->
                <div v-if="task.status==1||(task.status==2&&progress)" style="display: flex;align-items: center;">
                    <img class="my_animation" src="@/assets/images/imageSaver/loadingBlue.png" />
                    <div class="status-txt-text" style="padding-left:5px;" :style="showProgressPopup?'':'pointer-events: none;'" @click="openPopup(6)">{{getPercentAndSpeed}}</div>
                    <div class="speed-up-btn" v-if="!user.vip&&showProgressPopup" @click="openPopup(6)">
                        <img src="@/assets/images/vectorImg/speed_up.svg">
                        <div class="speed-up-txt">{{$t('language.taskList.speedUP')}}</div>
                    </div>
                </div>
                <!-- 等待状态 -->
                <div v-if="task.status==2&&!progress" class="task-waiting" style="display: flex;align-items: center;">
                    <img class="my_animation" src="@/assets/images/imageSaver/loading2.png" />
                    <div class="status-txt-text" style="padding-left:5px;">{{$t('language.common.waiting')+'...'}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import common_util from '../../../../js/workspace/common_util';
export default {
    props: ['task'],
    computed: {
        //计算关闭状态任务结果
        convertResult() {
            var result;
            if(this.task.status==0) {
                switch (this.task.result) {
                    case -1:
                        result = 'failure';
                        break;
                    case 0:
                        result = 'canceled';
                        break;
                    case 1:
                        result = 'success';
                        break;
                    case 2:
                        result = 'patial';
                        break;
                    default:
                        break;
                }
            }
            return result;
        },
        //计算运行中任务的显示
        getPercentAndSpeed() {
            let percent = 0;
            console.log("test",this.progress)
            let speed = '';
            if(this.progress) {
                if(!isNaN(this.progress.percent)) {
                    percent = this.progress.percent;
                }
                if(this.progress.speed) {
                    speed = this.progress.speed;
                }
                if(percent>100) {
                    percent = 100;
                }
                return percent+"%"+"..." + speed;
            }else {
                return "0%";
            }
        },
        //是否允许打开进度弹窗
        showProgressPopup() {
            let type = this.task.type;
            if(type == 1 || type ==6) {
                //只有传输和备份有进度信息
                return true;
            }else {
                return false;
            }
        }
    },
    data: function() {
        return {
            user: common_util.getUser(),
            progress: null,
        }
    },
    watch: {
        '$store.state.taskProgress': function (newValue, oldValue) {
            if(newValue[this.task.id]) {
                this.progress = newValue[this.task.id];
            }else {
                this.progress = null;
            }
        },
    },
    methods: {
        //打开对应功能弹出窗口
        openPopup(type) {
            /*  type参数:
                1: 日志详情窗口 viewLogsOpen
                2: 任务设置窗口 openOptionsDialog
                3: 删除任务窗口 deleteTaskItem
                4: 还原情况窗口 openBackupRestore
                5: 备份版本信息窗口 openVersions
                6: 任务进度信息窗口 openProgress
             */
            //打开弹窗
            console.log(type,this.task)
            this.$emit("open-popup",type,this.task);
        },
    }
}
</script>

<style scoped>
.function-status {
    flex-grow: 1;
}

/* 旋转 */
.my_animation {
    animation: rotating 2s linear infinite;
}
</style>


// WEBPACK FOOTER //
// src/components/common/tabs/tabs_task_list/tab_task_status.vue